/**
 * drawer-header-offset.js
 * Aligne le haut des drawers mobile (#NavDrawer, drawer panier, #ReserveDrawer) sur le bas
 * RÉEL du header collé, au lieu d'une valeur hardcodée. Le header mobile change de hauteur au
 * scroll (état slim « header-mobile-scrolled ») : un top fixe (152px) laisse un trou quand le
 * header est plus court. On mesure le bas du header et on l'expose en --mobile-header-h.
 * Consommé par `.drawer` dans assets/mint.css (@media max-width:979px), fallback 152px.
 *
 * NB : on ne se fie pas à un seul élément (cf. anti-pattern #SiteHeader.bottom) — on prend le
 * bas le plus bas parmi les barres fixes/sticky ancrées en haut (announcement + header).
 */
(function () {
  'use strict';
  var root = document.documentElement;
  var SELECTORS = ['#AnnouncementBarCustom', '#SiteHeader'];

  function headerBottom() {
    var b = 0;
    for (var i = 0; i < SELECTORS.length; i++) {
      var el = document.querySelector(SELECTORS[i]);
      if (!el) continue;
      var cs = getComputedStyle(el);
      if (cs.position !== 'fixed' && cs.position !== 'sticky') continue;
      var rect = el.getBoundingClientRect();
      if (rect.height > 0 && rect.top < 250) b = Math.max(b, rect.bottom);
    }
    return Math.max(0, Math.round(b));
  }

  // Écriture seulement si la valeur change : une variable posée sur <html> invalide le
  // style de toute la page, et le scroll déclenche cet appel à chaque frame.
  var raf = 0;
  var lastValue = '';
  function apply() {
    raf = 0;
    var value = headerBottom() + 'px';
    if (value === lastValue) return;
    lastValue = value;
    root.style.setProperty('--mobile-header-h', value);
  }
  function schedule() {
    if (raf) return;
    raf = window.requestAnimationFrame(apply);
  }

  apply();
  window.addEventListener('scroll', schedule, { passive: true });
  window.addEventListener('resize', schedule, { passive: true });
  /*
   * Le header change AUSSI de hauteur sans qu'aucun de ces trois événements ne parte :
   * l'ouverture de la barre de recherche mobile lui ajoute 63px, sa fermeture les reprend.
   * Sans observation de taille, `--mobile-header-h` gardait la valeur d'AVANT la fermeture et
   * le tiroir s'ouvrait 63px trop bas — mesuré le 2026-09-16 à 390px sur une collection, barre
   * de recherche ouverte puis burger : `#NavDrawer` à `top 177` pour un header revenu à 114,
   * soit un trou de 63px sur toute la largeur, et un tiroir raccourci d'autant (667 au lieu
   * de 730). Observer les barres elles-mêmes couvre tout changement de hauteur, quelle qu'en
   * soit la cause, là où la liste d'événements ci-dessus doit être tenue à jour à la main.
   */
  if (typeof ResizeObserver !== 'undefined') {
    var observateur = new ResizeObserver(schedule);
    for (var s = 0; s < SELECTORS.length; s++) {
      var barre = document.querySelector(SELECTORS[s]);
      if (barre) observateur.observe(barre);
    }
  }
  // Layout tardif (web fonts, rendu de l'announcement bar) : quelques recalculs après chargement.
  window.addEventListener('load', schedule);
  setTimeout(apply, 300);
  setTimeout(apply, 1000);
})();
